import { Grid, Typography } from 'gu-ui-kit'
import format from 'utils/dateFns/format'
import React from 'react'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'

export const DateCell = ({ created_at }) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()

  return (
    <Grid
      gap={!breakpoints.xl ? 8 : 4}
      direction={!breakpoints.xl ? 'row' : 'column'}
    >
      <Typography
        variant={!breakpoints.xl ? 'Body-10' : 'Body-Forms-15'}
        color={'Label-Fifth'}
        component={'div'}
      >
        {!breakpoints.xl && (
          <>
            {t('referral::referral_clients.table.head.created_at.label')}
            {': '}
          </>
        )}
        {format(Date.parse(created_at), 'dd.MM.yyyy')}
      </Typography>
      <Typography
        variant={!breakpoints.xl ? 'Body-10' : 'Body-Forms-Description-10'}
        color={'Label-Secondary'}
        component={'div'}
      >
        {format(Date.parse(created_at), 'HH:mm')}
      </Typography>
    </Grid>
  )
}

DateCell.propTypes = {
  created_at: PropTypes.string,
}
